namespace Solovis.Reports.Parts.Tables {

    export interface ColumnChoiceControlOptions extends Solovis.UI.BaseControlOptions {
        columnSet: DataTableHelpers.ColumnSet;
        selectedColumnId: string;
    }

    export class ColumnChoiceControl extends Solovis.UI.BaseControl {

        private _options: ColumnChoiceControlOptions;

        private _choiceDiv;
        private _choiceControl: DevExpress.ui.dxSelectBox;

        constructor(options: ColumnChoiceControlOptions) {
            super(options);

            this._options = options;this.notifyInitComplete            
        }

        public doRender() {
            let columns = this._options.columnSet.getColumnList();

            let selectedFound = false;

            var optionList = [];           

            if (!this._options.selectedColumnId) {
                selectedFound = true;
            }

            for (let col of columns) {
                let colLabel = col.getCompositeLabel();
                optionList.push({ text: colLabel, value: col.id});
                
                if (col.id === this._options.selectedColumnId) {
                    selectedFound = true;
                }
            }

            if (!selectedFound) {
                optionList.push({ text: this._options.selectedColumnId, value: this._options.selectedColumnId });
            }
             
            this._choiceDiv = $("<div>").appendTo(this.container);

            $(this._choiceDiv).dxSelectBox({
                displayExpr: "text",
                valueExpr: "value",
                dataSource: optionList,
                searchEnabled: true,
                searchMode: "contains",
                showClearButton: true,
                value: this._options.selectedColumnId
            });           

            this._choiceControl = $(this._choiceDiv).dxSelectBox("instance");
        }

        public value(newValue?: string) {
            if (arguments.length === 0) {
                if (this._choiceControl) {
                    return this._choiceControl.option("value");
                }
                else {
                    return this._options.selectedColumnId;
                }
            }
            else {
                let newValue = this._options.selectedColumnId ? this._options.selectedColumnId : null;
                this._choiceControl.option("value", newValue);
            }
        }

        public getValue() {
            let selectValue = this.value();
            if (selectValue) {
                return selectValue;
            }
            else {
                return null;
            }
        }

        public setValue(newValue: string) {
            this.value(newValue);
        }
    }

}